module.exports = __webpack_public_path__ + "static/media/localhost_MBLearning_index.php.ab9214bc.png";